var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{fluid: _vm.fluid, square: _vm.square, loading: _vm.loading}},[(_vm.loading)?_c('Loading'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }